import { configureStore } from "@reduxjs/toolkit";
import { restApi } from "./rest_api";
import { setupListeners } from "@reduxjs/toolkit/query";
import { adminApi } from "@/store/admin_api";

export const store = configureStore({
  reducer: {
    [restApi.reducerPath]: restApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(restApi.middleware, adminApi.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

interface RefreshResponse {
  // eslint-disable-next-line camelcase
  id_token: string;
  // eslint-disable-next-line camelcase
  access_token: string;
}
